import { gql } from 'graphql-tag';

/**
 * These queries use @connection directive to create unique Apollo cache keys.
 *
 * Without @connection, all these persisted queries have identical selection sets
 * (`{ company }`) which causes Apollo to treat them as the same cached query.
 * This leads to cache conflicts when switching between payable types (bill vs
 * claimedBill), where one query returns cached data meant for another query
 *
 * The @connection directive is client-only and creates separate cache entries
 * for each query, preventing stale data from being returned.
 */

export const GET_DEFAULT_EMPLOYEE_ACCOUNTS = gql`
  query Id4a5badf9c0fcfc2558d38da71c2e464d($companyId: ID!) {
    company @connection(key: "defaultEmployeeAccounts")
  }
`;

export const GET_DEFAULT_SUPPLIER_ACCOUNTS = gql`
  query Id387d2313f2f2f3f204841c37acc43104($companyId: ID!) {
    company @connection(key: "defaultSupplierAccounts")
  }
`;

export const GET_EMPLOYEE_ACCOUNT = gql`
  query Id5b4bf3a51895e6f3b48cb5ab77455f83($companyId: ID!, $userId: String!) {
    company @connection(key: "employeeAccount")
  }
`;

export const GET_PAYABLES_COUNT = gql`
  query Idb7bc1b65ca20089cfbbb84c64487d082(
    $companyId: ID!
    $after: ID
    $filtersV2: JSON
  ) {
    company
  }
`;
